import * as React from 'react';

import { cn } from '@/lib/utils';

export function SectionBrandLogos() {
  return (
    <section className="redesign-container border-b flex flex-col justify-center items-center py-4 gap-y-2">
      <div className="relative grid grid-cols-3 w-full gap-x-4 max-sm:[mask-image:linear-gradient(to_right,transparent,white_20%,white_80%,transparent)]">
        {[...brandLogos].map((logo, index) => (
          <div
            key={index}
            className={cn('flex items-center justify-start w-full', {
              'justify-center': index === 1,
              'justify-end': index === 2,
            })}
          >
            {logo.logo}
          </div>
        ))}
      </div>
    </section>
  );
}

const brandLogos = [
  {
    name: 'Quickrant',
    logo: (
      <img loading="lazy"
        width={140}
        height={40}
        src="/img/quickrant.svg"
        alt="quickrant.com"
      />
    ),
  },
  {
    name: 'Candy',
    logo: <img loading="lazy" width={110} height={40} src="/img/candy.svg" alt="candy.io" />,
  },
  {
    name: 'Retro Rabbit',
    logo: (
      <div className="flex items-center gap-1">
        <img loading="lazy"
          width={40}
          height={40}
          src="/img/retrorabbit.png"
          className="h-12 grayscale"
          alt="retrorabbit.io"
        />
        <span
          className={cn(
            'text-lg text-white font-semibold flex-shrink-0',
            'font-merriweather',
          )}
        >
          Retro <span className="text-gray-400">Rabbit</span>
        </span>
      </div>
    ),
  },
];
